<template>
  <div>
    <v-checkbox
      v-for="item in items"
      :key="item[valueField]"
      :label="item[labelField]"
      :value="item[valueField]"
      v-model="selected"
      @change="change"
    />
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    labelField: {
      type: String,
      required: true,
    },
    valueField: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.setSeletedItems();
      },
    },
  },
  created() {
    this.setSeletedItems();
  },
  methods: {
    change() {
      // tslint:disable-next-line: no-bitwise
      const seleted = this.selected.reduce((prev, curr) => curr | prev, 0);
      this.$emit('input', seleted);
    },
    setSeletedItems() {
      this.selected = (this.value || 0)
        .toString(2)
        .split('')
        .reverse()
        // tslint:disable-next-line: no-bitwise
        .map((i, idx) => (+i ? 1 << idx : NaN))
        .filter((i) => i);
    },
  },
};
</script>
